// extracted by mini-css-extract-plugin
module.exports = {"heading":"people_heading__3g_tG","element":"people_element__1WzoG","list":"people_list__HmG09"};